// tslint:disable
export var RefundAbilityStatus;
(function (RefundAbilityStatus) {
    RefundAbilityStatus["REFUNDABLE"] = "REFUNDABLE";
    RefundAbilityStatus["MANUAL"] = "MANUAL";
    RefundAbilityStatus["NOT_REFUNDABLE"] = "NOT_REFUNDABLE";
})(RefundAbilityStatus || (RefundAbilityStatus = {}));
export var NotRefundableReason;
(function (NotRefundableReason) {
    NotRefundableReason["ALREADY_REFUNDED"] = "ALREADY_REFUNDED";
    NotRefundableReason["PROVIDER_IS_DOWN"] = "PROVIDER_IS_DOWN";
    NotRefundableReason["NOT_SUPPORTED"] = "NOT_SUPPORTED";
    NotRefundableReason["EXPIRED"] = "EXPIRED";
    NotRefundableReason["NOT_FOUND"] = "NOT_FOUND";
    NotRefundableReason["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    NotRefundableReason["NOT_PAID"] = "NOT_PAID";
    NotRefundableReason["ACCESS_DENIED"] = "ACCESS_DENIED";
    NotRefundableReason["ZERO_PRICE"] = "ZERO_PRICE";
    NotRefundableReason["OFFLINE"] = "OFFLINE";
    NotRefundableReason["DISABLE_BY_VENDOR"] = "DISABLE_BY_VENDOR";
    NotRefundableReason["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    NotRefundableReason["DEPOSIT_ONLINE_ITEM"] = "DEPOSIT_ONLINE_ITEM";
    NotRefundableReason["PENDING_REFUND"] = "PENDING_REFUND";
    NotRefundableReason["FORBIDDEN"] = "FORBIDDEN";
})(NotRefundableReason || (NotRefundableReason = {}));
export var SubscriptionPlanFrequency;
(function (SubscriptionPlanFrequency) {
    SubscriptionPlanFrequency["MONTH"] = "MONTH";
    SubscriptionPlanFrequency["DAY"] = "DAY";
    SubscriptionPlanFrequency["WEEK"] = "WEEK";
    SubscriptionPlanFrequency["YEAR"] = "YEAR";
    SubscriptionPlanFrequency["UNDEFINED"] = "UNDEFINED";
})(SubscriptionPlanFrequency || (SubscriptionPlanFrequency = {}));
export var Source;
(function (Source) {
    Source["UNSUPPORTED_SOURCE"] = "UNSUPPORTED_SOURCE";
    Source["WIX_FACEBOOK_ADS"] = "WIX_FACEBOOK_ADS";
})(Source || (Source = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Paid"] = "Paid";
    PaymentStatus["NotPaid"] = "NotPaid";
    PaymentStatus["Refunded"] = "Refunded";
    PaymentStatus["PartiallyPaid"] = "PartiallyPaid";
})(PaymentStatus || (PaymentStatus = {}));
export var ShippingStatus;
(function (ShippingStatus) {
    ShippingStatus["Fulfilled"] = "Fulfilled";
    ShippingStatus["NotFulfilled"] = "NotFulfilled";
    ShippingStatus["Canceled"] = "Canceled";
})(ShippingStatus || (ShippingStatus = {}));
export var FulfillmentStatus;
(function (FulfillmentStatus) {
    FulfillmentStatus["Fulfilled"] = "Fulfilled";
    FulfillmentStatus["NotFulfilled"] = "NotFulfilled";
    FulfillmentStatus["PartiallyFulfilled"] = "PartiallyFulfilled";
    FulfillmentStatus["Canceled"] = "Canceled";
})(FulfillmentStatus || (FulfillmentStatus = {}));
export var ActiveStatus;
(function (ActiveStatus) {
    ActiveStatus["Active"] = "Active";
    ActiveStatus["Archived"] = "Archived";
})(ActiveStatus || (ActiveStatus = {}));
export var ReadStatus;
(function (ReadStatus) {
    ReadStatus["Read"] = "Read";
    ReadStatus["NotRead"] = "NotRead";
})(ReadStatus || (ReadStatus = {}));
export var SalesChannels;
(function (SalesChannels) {
    SalesChannels["Web"] = "Web";
    SalesChannels["Pos"] = "Pos";
    SalesChannels["Ebay"] = "Ebay";
    SalesChannels["Amazon"] = "Amazon";
    SalesChannels["OtherPlatform"] = "OtherPlatform";
    SalesChannels["WixAppStore"] = "WixAppStore";
})(SalesChannels || (SalesChannels = {}));
export var OrderSortField;
(function (OrderSortField) {
    OrderSortField["IncrementId"] = "IncrementId";
    OrderSortField["Quantity"] = "Quantity";
    OrderSortField["CreationDate"] = "CreationDate";
    OrderSortField["CustomerName"] = "CustomerName";
    OrderSortField["PaymentStatus"] = "PaymentStatus";
    OrderSortField["ShippingStatus"] = "ShippingStatus";
    OrderSortField["Total"] = "Total";
    OrderSortField["FulfillmentStatus"] = "FulfillmentStatus";
    OrderSortField["LastUpdated"] = "LastUpdated";
    OrderSortField["DeliveryTimeSlotFromDate"] = "DeliveryTimeSlotFromDate";
    OrderSortField["DeliveryTimeSlotToDate"] = "DeliveryTimeSlotToDate";
})(OrderSortField || (OrderSortField = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "Ascending";
    SortDirection["Descending"] = "Descending";
})(SortDirection || (SortDirection = {}));
export var OrderInHistoryStatus;
(function (OrderInHistoryStatus) {
    OrderInHistoryStatus["Confirmed"] = "Confirmed";
    OrderInHistoryStatus["Shipped"] = "Shipped";
    OrderInHistoryStatus["Fulfilled"] = "Fulfilled";
    OrderInHistoryStatus["Tracking"] = "Tracking";
    OrderInHistoryStatus["Canceled"] = "Canceled";
})(OrderInHistoryStatus || (OrderInHistoryStatus = {}));
/**
 * Why is the Shipping Label feature not available
 */
export var ShippingLabelUnavailabilityReason;
(function (ShippingLabelUnavailabilityReason) {
    ShippingLabelUnavailabilityReason["FEATURE_KILLED"] = "FEATURE_KILLED";
    ShippingLabelUnavailabilityReason["INELIGIBLE_STORE"] = "INELIGIBLE_STORE";
})(ShippingLabelUnavailabilityReason || (ShippingLabelUnavailabilityReason = {}));
export var ContentTypes;
(function (ContentTypes) {
    ContentTypes["gift"] = "gift";
    ContentTypes["merchandise"] = "merchandise";
    ContentTypes["other"] = "other";
})(ContentTypes || (ContentTypes = {}));
export var ProductGroupRateCalculationSettingType;
(function (ProductGroupRateCalculationSettingType) {
    ProductGroupRateCalculationSettingType["APPLY_RATE_TO_EACH_PRODUCT"] = "APPLY_RATE_TO_EACH_PRODUCT";
    ProductGroupRateCalculationSettingType["APPLY_RATE_ONCE_PER_GROUP"] = "APPLY_RATE_ONCE_PER_GROUP";
    ProductGroupRateCalculationSettingType["APPLY_HIGHEST_RATE_ONCE"] = "APPLY_HIGHEST_RATE_ONCE";
})(ProductGroupRateCalculationSettingType || (ProductGroupRateCalculationSettingType = {}));
export var PlanDiscountMode;
(function (PlanDiscountMode) {
    PlanDiscountMode["AMOUNT"] = "AMOUNT";
    PlanDiscountMode["PERCENT"] = "PERCENT";
})(PlanDiscountMode || (PlanDiscountMode = {}));
export var GiftCardError;
(function (GiftCardError) {
    GiftCardError["GIFT_CARD_GENERAL_ERROR"] = "GIFT_CARD_GENERAL_ERROR";
    GiftCardError["GIFT_CARD_INSUFFICIENT_BALANCE"] = "GIFT_CARD_INSUFFICIENT_BALANCE";
    GiftCardError["GIFT_CARD_CODE_INVALID"] = "GIFT_CARD_CODE_INVALID";
    GiftCardError["GIFT_CARD_CURRENCY_INVALID"] = "GIFT_CARD_CURRENCY_INVALID";
    GiftCardError["GIFT_CARD_EXPIRED"] = "GIFT_CARD_EXPIRED";
    GiftCardError["GIFT_CARD_DISABLED"] = "GIFT_CARD_DISABLED";
    GiftCardError["GIFT_CARD_IS_EMPTY"] = "GIFT_CARD_IS_EMPTY";
    GiftCardError["GIFT_CARD_SERVICE_UNAVAILABLE"] = "GIFT_CARD_SERVICE_UNAVAILABLE";
})(GiftCardError || (GiftCardError = {}));
export var StringOperator;
(function (StringOperator) {
    StringOperator["Equals"] = "Equals";
    StringOperator["Contains"] = "Contains";
})(StringOperator || (StringOperator = {}));
export var InventoryStatus;
(function (InventoryStatus) {
    InventoryStatus["IN_STOCK_STATUS"] = "IN_STOCK_STATUS";
    InventoryStatus["OUT_OF_STOCK_STATUS"] = "OUT_OF_STOCK_STATUS";
    InventoryStatus["NOT_OUT_OF_STOCK_STATUS"] = "NOT_OUT_OF_STOCK_STATUS";
    InventoryStatus["PARTIALLY_OUT_OF_STOCK_STATUS"] = "PARTIALLY_OUT_OF_STOCK_STATUS";
})(InventoryStatus || (InventoryStatus = {}));
export var ProductType;
(function (ProductType) {
    ProductType["Physical"] = "Physical";
    ProductType["Digital"] = "Digital";
})(ProductType || (ProductType = {}));
export var ProductFieldName;
(function (ProductFieldName) {
    ProductFieldName["name"] = "name";
    ProductFieldName["creationDate"] = "creationDate";
    ProductFieldName["createVersion"] = "createVersion";
    ProductFieldName["price"] = "price";
    ProductFieldName["comparePrice"] = "comparePrice";
    ProductFieldName["discountedPrice"] = "discountedPrice";
    ProductFieldName["description"] = "description";
    ProductFieldName["ribbon"] = "ribbon";
    ProductFieldName["sku"] = "sku";
    ProductFieldName["visible"] = "visible";
    ProductFieldName["deleted"] = "deleted";
    ProductFieldName["created"] = "created";
    ProductFieldName["categories"] = "categories";
    ProductFieldName["id"] = "id";
    ProductFieldName["productType"] = "productType";
    ProductFieldName["inventoryStatus"] = "inventoryStatus";
    ProductFieldName["optionChoices"] = "optionChoices";
    ProductFieldName["slug"] = "slug";
    ProductFieldName["taxGroupId"] = "taxGroupId";
    ProductFieldName["handleId"] = "handleId";
    ProductFieldName["lastUpdated"] = "lastUpdated";
    ProductFieldName["shippingProductGroupId"] = "shippingProductGroupId";
    ProductFieldName["planIds"] = "planIds";
    ProductFieldName["allowOneTimePurchase"] = "allowOneTimePurchase";
    ProductFieldName["fulfillerId"] = "fulfillerId";
    ProductFieldName["readyToSellExternalAppId"] = "readyToSellExternalAppId";
    ProductFieldName["hideFromPos"] = "hideFromPos";
    ProductFieldName["brand"] = "brand";
    ProductFieldName["preOrder"] = "preOrder";
})(ProductFieldName || (ProductFieldName = {}));
export var FilterOperators;
(function (FilterOperators) {
    FilterOperators["EQUALS"] = "EQUALS";
    FilterOperators["NEQUALS"] = "NEQUALS";
    FilterOperators["GT"] = "GT";
    FilterOperators["GTE"] = "GTE";
    FilterOperators["LT"] = "LT";
    FilterOperators["LTE"] = "LTE";
    FilterOperators["BETWEEN"] = "BETWEEN";
    FilterOperators["IN"] = "IN";
    FilterOperators["IN_ALL"] = "IN_ALL";
    FilterOperators["CONTAINS"] = "CONTAINS";
    FilterOperators["START_WITH"] = "START_WITH";
    FilterOperators["MATCH"] = "MATCH";
    FilterOperators["CONTAINS_ALL"] = "CONTAINS_ALL";
    FilterOperators["CONTAINS_ANY"] = "CONTAINS_ANY";
    FilterOperators["EXISTS"] = "EXISTS";
})(FilterOperators || (FilterOperators = {}));
export var ProductSortField;
(function (ProductSortField) {
    ProductSortField["Name"] = "Name";
    ProductSortField["CreationDate"] = "CreationDate";
    ProductSortField["CreateVersion"] = "CreateVersion";
    ProductSortField["Price"] = "Price";
    ProductSortField["ComparePrice"] = "ComparePrice";
    ProductSortField["DiscountedPrice"] = "DiscountedPrice";
    ProductSortField["Id"] = "Id";
    ProductSortField["LastUpdated"] = "LastUpdated";
    ProductSortField["name"] = "name";
    ProductSortField["creationDate"] = "creationDate";
    ProductSortField["createVersion"] = "createVersion";
    ProductSortField["price"] = "price";
    ProductSortField["comparePrice"] = "comparePrice";
    ProductSortField["discountedPrice"] = "discountedPrice";
    ProductSortField["id"] = "id";
    ProductSortField["lastUpdated"] = "lastUpdated";
})(ProductSortField || (ProductSortField = {}));
export var ProductOptionType;
(function (ProductOptionType) {
    ProductOptionType["DROP_DOWN"] = "DROP_DOWN";
    ProductOptionType["COLOR"] = "COLOR";
})(ProductOptionType || (ProductOptionType = {}));
export var MeasurementUnitType;
(function (MeasurementUnitType) {
    MeasurementUnitType["ml"] = "ml";
    MeasurementUnitType["cl"] = "cl";
    MeasurementUnitType["l"] = "l";
    MeasurementUnitType["cbm"] = "cbm";
    MeasurementUnitType["mg"] = "mg";
    MeasurementUnitType["g"] = "g";
    MeasurementUnitType["kg"] = "kg";
    MeasurementUnitType["mm"] = "mm";
    MeasurementUnitType["cm"] = "cm";
    MeasurementUnitType["m"] = "m";
    MeasurementUnitType["sqm"] = "sqm";
    MeasurementUnitType["oz"] = "oz";
    MeasurementUnitType["lb"] = "lb";
    MeasurementUnitType["floz"] = "floz";
    MeasurementUnitType["pt"] = "pt";
    MeasurementUnitType["qt"] = "qt";
    MeasurementUnitType["gal"] = "gal";
    MeasurementUnitType["in"] = "in";
    MeasurementUnitType["ft"] = "ft";
    MeasurementUnitType["yd"] = "yd";
    MeasurementUnitType["sqft"] = "sqft";
})(MeasurementUnitType || (MeasurementUnitType = {}));
export var DiscountMode;
(function (DiscountMode) {
    DiscountMode["Amount"] = "Amount";
    DiscountMode["Percent"] = "Percent";
})(DiscountMode || (DiscountMode = {}));
export var CategoryFieldName;
(function (CategoryFieldName) {
    CategoryFieldName["id"] = "id";
    CategoryFieldName["name"] = "name";
    CategoryFieldName["numOfProducts"] = "numOfProducts";
    CategoryFieldName["parentCategoryId"] = "parentCategoryId";
})(CategoryFieldName || (CategoryFieldName = {}));
export var StoreVariantSortField;
(function (StoreVariantSortField) {
    StoreVariantSortField["ProductNumericId"] = "ProductNumericId";
    StoreVariantSortField["VariantId"] = "VariantId";
    StoreVariantSortField["productNumericId"] = "productNumericId";
    StoreVariantSortField["variantId"] = "variantId";
})(StoreVariantSortField || (StoreVariantSortField = {}));
export var ProductBrandFieldName;
(function (ProductBrandFieldName) {
    ProductBrandFieldName["brand"] = "brand";
})(ProductBrandFieldName || (ProductBrandFieldName = {}));
/**
 * When inventory is going to be updated
 */
export var InventoryUpdatingMode;
(function (InventoryUpdatingMode) {
    InventoryUpdatingMode["OnOrderPaid"] = "OnOrderPaid";
    InventoryUpdatingMode["OnOrderCreated"] = "OnOrderCreated";
    InventoryUpdatingMode["Unknown"] = "Unknown";
})(InventoryUpdatingMode || (InventoryUpdatingMode = {}));
export var EmailStatusType;
(function (EmailStatusType) {
    EmailStatusType["SENT"] = "SENT";
    EmailStatusType["NOT_SENT"] = "NOT_SENT";
    EmailStatusType["SCHEDULED"] = "SCHEDULED";
})(EmailStatusType || (EmailStatusType = {}));
export var RecoveryStatusType;
(function (RecoveryStatusType) {
    RecoveryStatusType["RECOVERED"] = "RECOVERED";
    RecoveryStatusType["NOT_RECOVERED"] = "NOT_RECOVERED";
})(RecoveryStatusType || (RecoveryStatusType = {}));
export var AbandonedCartsSortField;
(function (AbandonedCartsSortField) {
    AbandonedCartsSortField["AbandonedDate"] = "AbandonedDate";
    AbandonedCartsSortField["AbandonTime"] = "AbandonTime";
})(AbandonedCartsSortField || (AbandonedCartsSortField = {}));
export var LockableOperation;
(function (LockableOperation) {
    LockableOperation["LOCKED"] = "LOCKED";
    LockableOperation["UNLOCKED"] = "UNLOCKED";
})(LockableOperation || (LockableOperation = {}));
export var RestrictableOperation;
(function (RestrictableOperation) {
    RestrictableOperation["ALLOW"] = "ALLOW";
    RestrictableOperation["WARN"] = "WARN";
})(RestrictableOperation || (RestrictableOperation = {}));
export var LockedOperations;
(function (LockedOperations) {
    LockedOperations["ManageProductPricing"] = "ManageProductPricing";
    LockedOperations["ManageProductVariants"] = "ManageProductVariants";
    LockedOperations["ManageProductInventory"] = "ManageProductInventory";
    LockedOperations["DuplicateProduct"] = "DuplicateProduct";
})(LockedOperations || (LockedOperations = {}));
export var EmailNotificationsConfiguration;
(function (EmailNotificationsConfiguration) {
    EmailNotificationsConfiguration["ON_ORDER_CREATED"] = "ON_ORDER_CREATED";
    EmailNotificationsConfiguration["ON_ORDER_PAID"] = "ON_ORDER_PAID";
    EmailNotificationsConfiguration["OFF"] = "OFF";
})(EmailNotificationsConfiguration || (EmailNotificationsConfiguration = {}));
export var MediaItemEnum;
(function (MediaItemEnum) {
    MediaItemEnum["PHOTO"] = "PHOTO";
    MediaItemEnum["UNSUPPORTED"] = "UNSUPPORTED";
})(MediaItemEnum || (MediaItemEnum = {}));
export var LineItemEnum;
(function (LineItemEnum) {
    LineItemEnum["UNSPECIFIED_LINE_ITEM_TYPE"] = "UNSPECIFIED_LINE_ITEM_TYPE";
    LineItemEnum["PHYSICAL"] = "PHYSICAL";
    LineItemEnum["DIGITAL"] = "DIGITAL";
    LineItemEnum["CUSTOM_AMOUNT_ITEM"] = "CUSTOM_AMOUNT_ITEM";
})(LineItemEnum || (LineItemEnum = {}));
export var WeightUnit;
(function (WeightUnit) {
    WeightUnit["KG"] = "KG";
    WeightUnit["LB"] = "LB";
})(WeightUnit || (WeightUnit = {}));
export var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["DAY"] = "DAY";
    SubscriptionFrequency["WEEK"] = "WEEK";
    SubscriptionFrequency["YEAR"] = "YEAR";
    SubscriptionFrequency["UNDEFINED"] = "UNDEFINED";
})(SubscriptionFrequency || (SubscriptionFrequency = {}));
// tslint:enable
//# sourceMappingURL=graphql-schema.js.map